import script from "./ConversationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ConversationPage.vue?vue&type=script&setup=true&lang=js"

import "./ConversationPage.vue?vue&type=style&index=0&id=70f31862&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70f31862"]])

export default __exports__